
import { createNamespacedHelpers } from 'vuex'
import { ACTION_OPEN_MODAL } from '../../store/actions/sidebar'
import { getCountryList } from '../../libs/wcs/sidebar/countries/countries'
import { loadSectionTranslations } from '../../i18n-setup'

const { mapActions, mapGetters } = createNamespacedHelpers('sidebar')

export default {
  name: 'sgh-country-selector-list',
  data() {
    return {
      selectedContinentCountries: [],
      selectedContinent: '',
      showCountryList: false,
      countries: {},
    }
  },
  computed: {
    ...mapGetters(['isModalOpen']),
    continents() {
      return Object.keys(this.countries)
    },
  },
  watch: {
    isModalOpen(newValue) {
      if (!newValue) {
        this.resetState()
      }
    },
  },
  mounted() {
    loadSectionTranslations('cms')
  },
  async created() {
    this.countries = await getCountryList()
  },
  methods: {
    ...mapActions({ openModal: ACTION_OPEN_MODAL }),
    closeSidebar() {
      this.openModal(false)
    },
    getCountriesByContinent(continentName) {
      this.showCountryList = true
      this.selectedContinent = continentName
      this.selectedContinentCountries = this.countries[continentName]
    },
    backToContinentList() {
      this.selectedContinent = ''
      this.showCountryList = false
    },
    resetState() {
      this.showCountryList = false
      this.selectedContinent = ''
      this.selectedContinentCountries = []
    },
    isCountrySelected(locale) {
      return window.wcs_config && window.wcs_config.locale === locale ? 'active-country' : ''
    },
  },
}
